/* eslint-disable react-hooks/exhaustive-deps */
import { Formik, Form } from 'formik';
import { useEffect } from 'react';
import PropTypes from 'prop-types';

import CommunicateToForm from '../../../../components/CommunicateToForm/CommunicateToForm';
import { CommunicateToPermissions } from '../../../../components/MonthlyServiceRequest/RequestDetailTypes';
import { DetailRequest, DetailRequestDefaultProp } from '../../../../utils/globalPropTypes';

const CommunicateToContainer = ({
  details,
  communicateToPermissions,
  setIsPendingAuthorization
}) => {
  const initialValues = {
    communicate: {
      receivers: [],
      adicionalReceivers: []
    }
  };

  useEffect(() => {
    setIsPendingAuthorization(false);
  }, []);

  return (
    <Formik initialValues={initialValues}>
      {() => (
        <Form>
          <CommunicateToForm
            communicateToPermissions={communicateToPermissions}
            details={details}
          />
        </Form>
      )}
    </Formik>
  );
};

CommunicateToContainer.propTypes = {
  communicateToPermissions: CommunicateToPermissions,
  details: DetailRequest,
  setIsPendingAuthorization: PropTypes.func
};
CommunicateToContainer.defaultProps = {
  communicateToPermissions: {
    visualize: false,
    write: false
  },
  details: DetailRequestDefaultProp,
  setIsPendingAuthorization: () => {}
};

export default CommunicateToContainer;
